import { forwardRef } from "react";
import cn from "classnames";

import Spinner from "../spinner";

const Button: React.FC<any> = forwardRef<any, any>(
	({ loading, disabled, children, full, variant = "base", className, ...btnProps }, ref) => {
		return (
			<button
				className={cn(
					"inline-flex items-center justify-center gap-2 rounded-lg font-semibold uppercase text-sm tracking-wide transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg cursor-pointer",
					className,
					{
						"w-full": full,
						"bg-surface text-white px-6 py-3 hover:bg-surface-hover": variant === "secondary",
						"bg-accent text-white px-6 py-3 hover:bg-accent-hover": variant === "accent",
						"bg-accent text-white px-6 py-3 hover:bg-accent-hover shadow-md shadow-accent/25 hover:shadow-lg hover:shadow-accent/40": variant === "base",
					}
				)}
				disabled={disabled || loading}
				ref={ref}
				{...btnProps}
			>
				{loading ? <Spinner size={1} /> : children}
			</button>
		);
	}
);

Button.displayName = "Button";
export default Button;
